import React from "react";

const ManageUserDetail = () => {
  return <div>ManageUserDetail</div>;
};

export default ManageUserDetail;
